<div class="overlay" (click)="cerrar()">
  <div class="modal-box" (click)="$event.stopPropagation()">
    <div class="header">
      <h3>Generar link de recuperación</h3>
      <button class="close-btn" (click)="cerrar()">&times;</button>
    </div>

    <div class="body">
      <p>Se generará un link de recuperación de contraseña para <strong>{{ email }}</strong>. El link podrás copiarlo y compartirlo manualmente.</p>

      <div class="input-row">
        <button (click)="generar()" [disabled]="loading || !email">
          {{ loading ? 'Generando...' : 'Generar link' }}
        </button>
      </div>

      <div class="loading" *ngIf="loading">Generando link de recuperación...</div>

      <div class="msg" *ngIf="mensaje" [class.success]="exito" [class.error]="!exito">
        {{ mensaje }}
      </div>

      <div class="link-box" *ngIf="recoveryLink">
        <input #linkInput type="text" [value]="recoveryLink" readonly (click)="linkInput.select()">
        <button class="copy-btn" [class.copied]="copiado" (click)="copiarLink(linkInput)">
          {{ copiado ? 'Copiado' : 'Copiar' }}
        </button>
      </div>
    </div>

    <div class="footer">
      <button (click)="cerrar()">Cerrar</button>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/admin/recovery-link-modal/recovery-link-modal.component.html